'use strict';
import React from 'react';
import classNames from 'classnames';
import Icon from './icon';

/**
 * Page level messages that can indicate information, warnings or errors.
 * Default style for page notification is success.
 * Variants for info, warning, and error priorities is supported.
 *
 * Usage:
 *
 * ```Javascript
 * <PageNotification type="error | info | success | warning" />
 * ```
 *
 * @extends {React.Component}
 * @property {String} type Renders the PageNotification message with a suitable icon and color for the defined type.
 */
class PageNotification extends React.Component {

  /**
   * @return {String} Component Icon CSS classname.
   */
  getIconClassName (type) {
    return classNames({
      'PageNotification-icon': true,
      [`PageNotification-icon--${type}`]: true
    });
  }

  /**
   * @return {String} Component CSS classname.
   */
  getComponentClassName (type) {
    return classNames({
      'PageNotification': true,
      [`PageNotification--${type}`]: true
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, type } = this.props;
    return (
      <div className={this.getComponentClassName(type)}>
        <Icon className={this.getIconClassName(type)} />
        <div className="PageNotification-content">
          { children }
        </div>
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the PageNotification component
 */
PageNotification.propTypes = {
  type: React.PropTypes.oneOf([
    'error', 'info', 'success', 'warning'
  ]).isRequired
};

export default PageNotification;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/pageNotification.jsx